import React from 'react';
import { useTheme } from '@mui/material';

const withTheme = (Component) =>
  function WithConfirm(props) {
    const theme = useTheme();
    return <Component {...props} theme={theme} />;
  };

export default withTheme;
